import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 25 25'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M11.838 16.888h1.5v-5.75h-1.5zm.75-7.462q.343 0 .575-.232a.78.78 0 0 0 .233-.575.78.78 0 0 0-.233-.576.78.78 0 0 0-.575-.232.78.78 0 0 0-.576.232.78.78 0 0 0-.232.576q0 .342.232.575a.78.78 0 0 0 .576.232m.002 12.212a9.3 9.3 0 0 1-3.706-.748 9.6 9.6 0 0 1-3.017-2.03 9.6 9.6 0 0 1-2.03-3.016 9.25 9.25 0 0 1-.75-3.704q0-1.972.749-3.706a9.6 9.6 0 0 1 2.03-3.017 9.6 9.6 0 0 1 3.016-2.03 9.25 9.25 0 0 1 3.704-.75q1.972 0 3.705.749a9.6 9.6 0 0 1 3.017 2.03 9.6 9.6 0 0 1 2.032 3.016 9.2 9.2 0 0 1 .748 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.017 9.6 9.6 0 0 1-3.016 2.032 9.25 9.25 0 0 1-3.704.748m-.002-1.5q3.35 0 5.675-2.325t2.325-5.675-2.325-5.675-5.675-2.325-5.675 2.325q-2.325 2.324-2.325 5.675t2.325 5.675 5.675 2.325'
    />
  </svg>
)
export default SvgComponent
